import { render, staticRenderFns } from "./DebtByTourId.vue?vue&type=template&id=606cfa67&"
import script from "./DebtByTourId.vue?vue&type=script&lang=js&"
export * from "./DebtByTourId.vue?vue&type=script&lang=js&"
import style0 from "./DebtByTourId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports